/*       */

import { combineReducers } from 'redux';
import users from './users/usersReducer';
import teams from './teams/teamsReducer';
import workspaces from './workspaces/workspacesReducer';
import license from './license/licenseReducer';
import llmProviders from './llmProviders/llmProvidersReducer';

export default combineReducers({
    users,
    teams,
    workspaces,
    license,
    llmProviders,
});
